import lodash from 'lodash';
import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { node, nodeWithArgs, toQuery, toMutation } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

export const ACTIONS = {
    SUBMIT_DOA_SIGN_TASK: 'SUBMIT_DOA_SIGN_TASK',
    GET_DOA_SIGNATURE_REQUEST: 'GET_DOA_SIGNATURE_REQUEST',
    UNLOAD_DOA_SIGNATURE_REQUEST: 'UNLOAD_DOA_SIGNATURE_REQUEST',
    CANCEL_DOA_SIGNATURE: 'CANCEL_DOA_SIGNATURE',
};

export function cancelDOATask(taskIdFrom, delegationIdFrom) {
    return async (dispatch, getState) => {
        const storeState = getState();

        const institutionId = lodash.get(storeState, 'me.institution.id');
        const task = lodash.get(storeState, 'form.signatureRequest');
        const taskId = taskIdFrom || lodash.get(task, 'id');
        const delegationId = delegationIdFrom || lodash.get(task, 'delegation.id');

        const mutation = nodeWithArgs('cancelDOATask', {
            input: {
                taskId,
                delegationId,
                institutionId,
            },
        });
        const response = await mutateGraphQL(toMutation(mutation));

        if (response && response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to cancel DOA signature'));
        } else {
            dispatch(getDOATask(taskId));
            dispatch(addApplicationMessage('success', 'DOA signature has been canceled.'));
            return response;
        }
    };
}

export function signDOATask({ signingToken }) {

    return async (dispatch, getState) => {
        const storeState = getState();
        const institutionId = lodash.get(storeState, 'me.institution.id');

        const task = lodash.get(storeState, 'form.signatureRequest');
        const taskId = lodash.get(task, 'id');
        const delegationId = lodash.get(task, 'delegation.id');
        const studyId = lodash.get(task, 'delegation.studyId');
        const binderId = lodash.get(task, 'delegation.binderId');
        const statement = lodash.get(task, 'statement');

        const query = toMutation(
            nodeWithArgs('signDOATask', {
                input: {
                    taskId,
                    studyId,
                    binderId,
                    signingToken,
                    delegationId,
                    institutionId,
                    statement,
                },
            })
        );

        const { errors, data } = await mutateGraphQL(query);
        if (errors) {
            dispatch(addApplicationMessage('error', 'Failed to sign DOA task'));
        } else {
            dispatch(addApplicationMessage('success', 'Tasks completed successfully.'));
            dispatch({
                type: ACTIONS.SUBMIT_DOA_SIGN_TASK,
                payload: {
                    success: data.signDOATask,
                },
            });
        }
    };
}

export function getDOATask(doaTaskId) {
    const query = toQuery(
        nodeWithArgs(
            'signatureRequest',
            {
                signatureRequestId: doaTaskId,
            },
            [
                'id',
                'status',
                node('createdBy', ['id', 'displayName']),
                node('requestedFrom', ['id', 'displayName', 'emailAddress']),
                node('delegation', [
                    'id',
                    'binderId',
                    'studyId',
                    node('user', ['id', 'displayName', 'emailAddress']),
                    node('rolesManagement', ['id', 'name']),
                    'taskIds',
                    'startDate',
                    'endDate',
                    node('tasks', ['id', 'taskName', 'taskIndex']),
                ]),
                'sentDate',
                'binderName',
                'statement',
            ]
        )
    );

    return async (dispatch) => {
        const { errors, data } = await queryGraphQL(query);

        if (errors) {
            dispatch(addApplicationMessage('error', 'Failed to load the DOA task'));
        } else {
            const { signatureRequest } = data;
            dispatch({
                type: ACTIONS.GET_DOA_SIGNATURE_REQUEST,
                payload: signatureRequest,
            });
            dispatch({
                type: 'SET_TASK_FOR_DETAIL_DISPLAY',
                payload: signatureRequest,
            });
        }
    };
}

export function unloadDOATask() {
    return (dispatch) => {
        dispatch({
            type: ACTIONS.UNLOAD_DOA_SIGNATURE_REQUEST,
        });
    };
}
